import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
export function noWhiteSpaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === "string" && value.length > 0 && value.trim().length === 0) {
      return { noWhiteSpace: true };
    }
    return null;
  };
}
